import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../../../api/agent";

export interface DealerSettings {
  id: string;
  dmsDealerId: number;
  hasMultipleSite: boolean;
}

export const dealerSettingsApi = createApi({
  reducerPath: "dealerSettingsApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["DealerSettings"],

  endpoints: (build) => ({
    getAllDealerSettings: build.mutation<any, void>({
      query: () => ({
        url: `api/DealerSettings/GetAll`,
        method: "get",
      }),
    }),
    updateDealerSettings: build.mutation<
      any,
      { dmsDealerId: number; hasMultipleSite: boolean }
    >({
      query: ({ dmsDealerId, hasMultipleSite }) => ({
        url: `api/DealerSettings/UpdateSettings`,
        method: "put",
        data: { dmsDealerId, hasMultipleSite },
      }),
      invalidatesTags: ["DealerSettings"],
    }),
    sendDealerEmail: build.mutation<
      any,
      {
        FromName: string;
        EmailTo: string;
        Subject: string;
        Body: string;
      }
    >({
      query: (payload) => ({
        url: `api/DealerSettings/SendEmail`,
        method: "post",
        data: payload,
      }),
    }),
    getAllFeatureFlags: build.mutation<any, void>({
      query: () => ({
        url: `api/DealerSettings/FeatureFlags`,
        method: "get",
      }),
    }),
    toggleFeatureFlag: build.mutation<
      any,
      { dmsSetupId: string; flagName: string; isEnabled: boolean }
    >({
      query: ({ dmsSetupId, flagName, isEnabled }) => ({
        url: `api/DealerSettings/FeatureFlags/Toggle`,
        method: "post",
        data: { dmsSetupId, flagName, isEnabled },
      }),
    }),
  }),
});

export const {
  useUpdateDealerSettingsMutation,
  useGetAllDealerSettingsMutation,
  useSendDealerEmailMutation,
  useGetAllFeatureFlagsMutation,
  useToggleFeatureFlagMutation,
} = dealerSettingsApi;

export const dealerSettingsReducer = dealerSettingsApi.reducer;
